const CardCheckoutErrorCodes = {
  PROGRAM_NOT_FOUND: 1000,
  CARD_DESIGN_NOT_FOUND: 1001,
  NO_PAYMENT_GATEWAY_CONNECTED: 1002,
  CHECKOUT_UNAVAILABLE: 1003,
  MAX_BALANCE_EXCEEDED: 1004,
  MINIMUM_TOPUP_AMOUNT: 1008,
  INVALID_PAYMENT_TOKEN: 1005,
  PROGRAM_NOT_ACTIVE: 1006,
  CHECKOUT_DISABLED: 1008
};

export default CardCheckoutErrorCodes;
